'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresOmalomaCustomerEditor = function () {
  function WinresOmalomaCustomerEditor($scope, $rootScope, omalomaService) {
    _classCallCheck(this, WinresOmalomaCustomerEditor);

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.omalomaService = omalomaService;
    this.userService = omalomaService.userService;
    this.passwordChangeModal = false;
    this.passwordChangeStatus = {
      callMade: {
        text: 'Lähetetään salasanaa'
      },
      waiting: {
        text: 'Odotetaan vastausta taustapalvelulta'
      },
      reseaved: {
        text: 'Salasanan vaihto sähköposti lähetetty.'
      }
    };
    // Password change status: Possible values:
    // init - Initializing
    // callMade - client pushed send button
    // waiting - waiting for backend
    // reseaved - backend finished
    this.setPasswordChangeStatus('init');

    // Current status. Possible values:
    // init - Initializing.
    // out - Not logged in.
    // loading - Loading info.
    // ready - Info loaded. Possibly just saved.
    // saving - Saving changes.
    // failure - Cannot display information. Note: a load error will cause this, a save error will not.
    //           In case of save error, state is set to 'ready' and the user can try again.
    //
    // The other two values are a notice to display, and an error to display.
    // Neither, one, or both may be set.
    // The values, if non-null, are passed to i18next.
    this.setStatus('init', null, null);
  }

  _createClass(WinresOmalomaCustomerEditor, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.$rootScope.$on('login', function () {
        return _this.load();
      });
      this.$rootScope.$on('logout', function () {
        _this.reset();
        _this.setStatus('out', null, null);
      });

      if (this.omalomaService.isLoggedInAsCustomer()) {
        this.load();
      } else {
        this.setStatus('out', null, null);
      }
    }
  }, {
    key: 'orderPasswordChangeEmail',
    value: function orderPasswordChangeEmail() {
      var _this2 = this;

      console.log("Paasu vaihtoon");
      this.callMade = true;
      this.setPasswordChangeStatus('callMade');
      var promiseOne = new Promise(function (hyva, paha) {
        _this2.setPasswordChangeStatus('waiting');
        _this2.omalomaService.sendAccountRecoveryMail('OmalomaDemo', _this2.$scope.customer.EmailAddress).then(function (response) {
          console.log(response);
          if (response != null) {
            hyva(response);
          }
        }).catch(function (err) {
          paha(err);
        });
      }).then(function (response) {
        console.log(response);
        _this2.setPasswordChangeStatus('reseaved');
      });
    }
  }, {
    key: 'setPasswordChangeStatus',
    value: function setPasswordChangeStatus(status) {
      this.$scope.passwordChangeStatus = status;
    }
  }, {
    key: 'closePasswordChangeModal',
    value: function closePasswordChangeModal() {
      this.passwordChangeModal = false;
    }
  }, {
    key: 'openPasswordChangeModal',
    value: function openPasswordChangeModal() {
      this.passwordChangeModal = true;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$scope.customer = null;
      this.$scope.originalEmail = null;
      this.$scope.emailConfirm = '';
      this.$scope.privacyPolicyURL = '#';
    }
  }, {
    key: 'load',
    value: function load() {
      var _this3 = this;

      this.reset();
      this.setStatus('loading', undefined, null);
      this.omalomaService.getCustomerInfo().then(function (customer) {
        _this3.$scope.customer = customer;
        console.log("[WOCE] Got customer info: ", customer);
        _this3.$scope.originalEmail = customer.EmailAddress;

        // If we were able to get customer info, we must be logged in.
        var connectionName = _this3.omalomaService.connectionNameIfLoggedIn();
        _this3.getPrivacyPolicy(connectionName);

        _this3.setStatus('ready', undefined, null);

        _this3.$scope.marketingParams = _this3.userService.getMarketingParams();

        if (_this3.marketingWatch) {
          // Cancel watch.
          _this3.marketingWatch();
        }

        _this3.marketingWatch = _this3.$scope.$watchGroup(['customer.AllowMarketing', 'customer.AllowElectronicMarketing', 'customer.DenyMarketing', 'customer.DenyElectronicMarketing'], function () {
          // Update negative marketing.
          // Deny = !Allow
          // Allow = !Deny
          _this3.updateNegativeMarketing(_this3.$scope.customer);
        });
      }).catch(function (error) {
        console.error('[WOCE] Failed to get customer info:', error);
        _this3.setStatus('error', undefined, 'load_failure');
      });
    }
  }, {
    key: 'save',
    value: function save() {
      var _this4 = this;

      var customer = this.$scope.customer;
      if (!customer) {
        console.error('[WOCE] No customer to save.');
        return;
      }

      // Update marketing dates to this day on save.
      customer.AllowMarketingDate = null;
      customer.AllowElectronicMarketingDate = null;

      this.setStatus('saving', null, null);
      this.omalomaService.saveCustomerInfo(customer).then(function (customerNumber) {
        if (customerNumber) {
          _this4.setStatus(undefined, 'saved', null);
          _this4.load();
        } else {
          throw 'Call returned: ' + customerNumber;
        }
      }).catch(function (error) {
        console.error('[WOCE] Failed to save customer info:', error);
        console.log('[WOCE] The customer info was:', customer);
        _this4.setStatus('ready', null, 'save_failure');
      });
    }
  }, {
    key: 'updateNegativeMarketing',
    value: function updateNegativeMarketing(customer) {
      if (this.$scope.marketingParams.Negative) {
        customer.AllowMarketing = !customer.DenyMarketing;
        customer.AllowElectronicMarketing = !customer.DenyElectronicMarketing;
      } else {
        customer.DenyMarketing = !customer.AllowMarketing;
        customer.DenyElectronicMarketing = !customer.AllowElectronicMarketing;
      }
    }
  }, {
    key: 'getPrivacyPolicy',
    value: function getPrivacyPolicy(winresConnectionName) {
      var _this5 = this;

      if (!winresConnectionName) {
        console.error("[WOCE] Failed to get booking conditions. No connection name.");
      } else {
        console.log('[WOCE] Getting site office parameters...  connection name is', winresConnectionName);
        this.omalomaService.getOfficeSiteParameters(winresConnectionName).then(function (params) {
          console.log("[WOCE] Got Office parameters, response: ", params);
          _this5.$scope.privacyPolicyURL = params.Office.PrivacyPolicyFi;
        }).catch(function (error) {
          console.error('[WOCE] Failed to get parameters:', error);
          if (error) {
            console.error("[WOCE]  Connection Name not ok");
            _this5.setConnectionStatusFalse();
          }
        });
      }
    }
  }, {
    key: 'setStatus',
    value: function setStatus(status, notice, error) {
      if (status !== undefined) {
        console.log('[WOCE] Set status to', status);
        this.$scope.status = status;
      }
      if (notice !== undefined) {
        if (notice) console.log('[WOCE] Notice:', notice);
        this.$scope.notice = notice;
      }
      if (error !== undefined) {
        if (error) console.log('[WOCE] Error:', error);
        this.$scope.error = error;
      }
    }
  }]);

  return WinresOmalomaCustomerEditor;
}();

WinresOmalomaCustomerEditor.$inject = ['$scope', '$rootScope', 'omalomaService'];

_module3.default.component('winresOmalomaCustomerEditor', {
  template: require('./winresOmalomaCustomerEditor.html'),
  controller: WinresOmalomaCustomerEditor,
  bindings: {},
  require: {}
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaCustomerEditor/winresOmalomaCustomerEditor.js
// module id = 328
// module chunks = 2